import { render } from "./VPermanentPatient.vue?vue&type=template&id=eabdcbaa&scoped=true"
import script from "./VPermanentPatient.vue?vue&type=script&lang=js"
export * from "./VPermanentPatient.vue?vue&type=script&lang=js"

import "./VPermanentPatient.vue?vue&type=style&index=0&id=eabdcbaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabdcbaa"]])

export default __exports__